import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../../layouts/dashboard';
import { PassengersBatch } from '../../../components/Passengers/PassengersBatch';

export const PassengerBatchPage = () => {
  return (
    <DashboardLayout title={'Pasajeros'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <PassengersBatch />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
